import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import NewReleasesRoundedIcon from "@mui/icons-material/NewReleasesRounded";
import CloseDialogButton from "../../../components/CloseDialogButton";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Delete",
  confirmColor = "error",
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
    >
      <div style={{ padding: 20, textAlign: "center", position: "relative" }}>
        <DialogTitle sx={{ p: 0 }}>
          <CloseDialogButton onClose={onClose} loading={loading} />
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <NewReleasesRoundedIcon
            style={{ fontSize: 48, marginBottom: 10 }}
            color={confirmColor === "error" ? "error" : "primary"}
          />
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
            {title}
          </Typography>
          {message && (
            <Typography color="text.secondary">{message}</Typography>
          )}
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: "center", mb: 1, gap: 1 }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            disabled={loading}
            sx={{ px: 4, textTransform: "none", fontWeight: 700 }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color={confirmColor}
            disabled={loading}
            sx={{ px: 4, textTransform: "none", fontWeight: 700 }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              confirmLabel
            )}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
